<template>
  <div>
    <v-container>
      <v-footer fixed app absolute>
        <v-toolbar-title class="ml-12 pl-12">
          <router-link to="/dashboard"
            ><img
              :src="require('@/assets/fplogo-iab.png')"
              width="100"
              alt="FP LOGO"
          /></router-link>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="mr-12 pr-12"> </v-toolbar-items>
      </v-footer>
    </v-container>
  </div>
</template>
<script>
export default {
  name: 'FooterLoggedIn',
  data() {
    return {
      showDialog: false
    }
  }
}
</script>
<style scoped lang="scss">
.v-footer {
  img {
    vertical-align: middle;
    border-style: none;
  }
  a {
    text-decoration: none;
  }
  .v-btn {
    height: 100% !important;
    .--active::before,
    &:before {
      display: none;
    }
    &:hover {
      color: #d9534f !important;
    }
  }
}
.layout {
  background-image: linear-gradient(135deg, #56a3b8 0%, #2d4453 100%);
}
</style>
